// removed by extract-text-webpack-plugin
module.exports = {"pageModule":"_2iSqS0onpa21pwiVZMV1ys","mainSubDiv":"_2PCtWbDBxRqUKLY-rUYHb","mainTitleDiv":"_3iaG-jesubBGIdZADP6HPZ","mainTitleContainer":"_1yXvn1HL1sIetw0rMrZdLV","moduleControls":"_60ogHrxhManihJDefSHqp","backToList":"_1mLU5cZwFk18CiPueu65TM","buttonOrganizer":"_2czypeBkrHIpXJaNYKtcN0","DSWizardButtonWrapper":"_2DhyHoWqwkwFJRVfHg7MFL"};


//////////////////
// WEBPACK FOOTER
// ./elements/ComponentPageDom.scss
// module id = 1180
// module chunks = 0